import React, { useState, useEffect } from 'react'
import StepBar from '../../atoms/StepBar/StepBar'

const StatoOrdineStepBar = ({ tipo_ordine, stato_ordine_calcolato, servicegift }) => {
  const [step, setStep] = useState(null)

  // se ordine SIPEC
  const NEUTRO = 'neutro'
  const PERSONALIZZATO = 'personalizzazione'
  const personalizzatoSteps = {
    1: 'Trasmesso',
    2: 'Inviata bozza digitale',
    3: 'Approvata bozza digitale',
    4: 'In lavorazione',
    5: 'Emesso DDT',
  }

  const neutroSteps = {
    1: 'Trasmesso',
    2: 'In preparazione',
    3: 'Emesso DDT',
  }

  // se ordine SG
  const ALTRO = 'Altro'
  const SIPEC = 'Sipec'

  const personalizzatoSipecSteps = {
    1: 'In attesa di approvazione',
    2: 'Trasmesso',
    3: 'Inviata bozza digitale',
    4: 'Approvata bozza digitale',
    5: 'In lavorazione',
    6: 'Emesso DDT',
  }

  const personalizzatoAltroSteps = {
    1: 'In attesa di approvazione',
    2: 'Trasmesso',
    3: 'Emesso DDT',
  }

  const neutroSgSteps = {
    1: 'In attesa di approvazione',
    2: 'Trasmesso',
    3: 'Emesso DDT',
  }

  useEffect(() => {
    if (servicegift) {
      if (tipo_ordine === PERSONALIZZATO && servicegift?.personalizzazione_type === ALTRO) {
        Object.keys(personalizzatoAltroSteps).forEach((key) => {
          if (personalizzatoAltroSteps[key] === stato_ordine_calcolato) {
            setStep(key)
          }
        })
      } else if (tipo_ordine === PERSONALIZZATO && servicegift?.personalizzazione_type === SIPEC) {
        Object.keys(personalizzatoSipecSteps).forEach((key) => {
          if (personalizzatoSipecSteps[key] === stato_ordine_calcolato) {
            setStep(key)
          }
        })
      } else if (tipo_ordine === NEUTRO) {
        Object.keys(neutroSgSteps).forEach((key) => {
          if (neutroSgSteps[key] === stato_ordine_calcolato) setStep(key)
        })
      }
    } else {
      if (tipo_ordine === NEUTRO) {
        Object.keys(neutroSteps).forEach((key) => {
          if (neutroSteps[key] === stato_ordine_calcolato) setStep(key)
        })
      } else if (tipo_ordine === PERSONALIZZATO) {
        Object.keys(personalizzatoSteps).forEach((key) => {
          if (personalizzatoSteps[key] === stato_ordine_calcolato) {
            setStep(key)
          }
        })
      }
    }
  }, [])

  return (
    <>
      {servicegift ? (
        <>
          {tipo_ordine === NEUTRO ? (
            <StepBar
              stepsLabels={Object.values(neutroSgSteps)}
              currentStep={step}
              navActive={true}
            />
          ) : tipo_ordine === PERSONALIZZATO && servicegift?.personalizzazione_type === SIPEC ? (
            <StepBar
              stepsLabels={Object.values(personalizzatoSipecSteps)}
              currentStep={step}
              navActive={true}
            />
          ) : tipo_ordine === PERSONALIZZATO && servicegift?.personalizzazione_type === ALTRO ? (
            <StepBar
              stepsLabels={Object.values(personalizzatoAltroSteps)}
              currentStep={step}
              navActive={true}
            />
          ) : null}
        </>
      ) : (
        <>
          {tipo_ordine === NEUTRO ? (
            <StepBar stepsLabels={Object.values(neutroSteps)} currentStep={step} navActive={true} />
          ) : tipo_ordine === PERSONALIZZATO ? (
            <StepBar
              stepsLabels={Object.values(personalizzatoSteps)}
              currentStep={step}
              navActive={true}
            />
          ) : null}
        </>
      )}
    </>
  )
}

export default StatoOrdineStepBar
